import { render, staticRenderFns } from "./ques-video.vue?vue&type=template&id=41fd0429&scoped=true"
import script from "./ques-video.vue?vue&type=script&lang=js"
export * from "./ques-video.vue?vue&type=script&lang=js"
import style0 from "./ques-video.vue?vue&type=style&index=0&id=41fd0429&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd0429",
  null
  
)

export default component.exports